<template>
  <div class="page mx-auto">
    <div class="page-content">
      <div class="container text-center">
        <h1 class="display-1 text-muted mb-5">
          Oops
        </h1>
        <p class="h4 text-muted font-weight-normal mb-7">
          We are sorry but our service is currently not available…
        </p>
        <b-button
          variant="sm-primary"
          size="lg"
          @click="goBack"
        >
          <i class="fa-light fa-arrow-left mr-2" /> Go back
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundComponent',

  methods: {
    goBack() {
      window.history.back();
    },
  },
};
</script>
